﻿function configureXsrfToken(xsrfToken: string) {
    $.ajaxPrefilter(function (options) {
        if (!options.beforeSend) {
            options.beforeSend = function (xhr) {
                xhr.setRequestHeader("X-XSRF-TOKEN", xsrfToken);
            }
        }
    });
}

window.configureXsrfToken = configureXsrfToken

$(function () {
    // Initialize tooltips with delegation for dynamic content
    $(document.body).tooltip({
        selector: "[data-toggle='tooltip']",
        container: 'body', // Append to body to avoid overflow clipping
        trigger: 'hover focus' // Default triggers
    });
});

// Clear the saved office selections from local storage when an impersonate form is submitted,
// so the impersonated user does not inherit the previous user's office scope.
// This will exist only for ecare but we are leaving it here for easier merging
const OFFICE_SELECTION_STORAGE_KEYS = [
    'selectedOfficeId',     // legacy single-select (jQuery office selector, Honor Cards)
    'selectedOfficeIds',    // numeric multiselect (Payment History, Orders report)
    'selectedLocationIds',  // GUID multiselect (Fundraising reports)
];

document.addEventListener('DOMContentLoaded', () => {
    // Select all submit buttons within the relevant forms
    const submitButtons = document.querySelectorAll('#employee-finder [type="submit"]');

    // Add a click event listener to each button
    submitButtons.forEach(button => {
        button.addEventListener('click', () => {
            OFFICE_SELECTION_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
        });
    });
});

// Show the "new" label if the current date is before the date specified in the data-new-until attribute
// This code will show the "new" label if the current date is before the date specified in the data-new-until attribute
document.addEventListener("DOMContentLoaded", () => {
    const now = new Date();

    document.querySelectorAll('.label.label-success[data-new-until]')
        .forEach(el => {
            const text = el.textContent?.trim().toLowerCase();
            const dateAttr = el.getAttribute('data-new-until');

            if (text === 'new' && dateAttr) {
                const [year, month, day] = dateAttr.split('-').map(Number);
                const expiry = new Date(year, month - 1, day + 1); // Include full last day

                if (now <= expiry) {
                    (el as HTMLElement).style.display = 'inline';
                }
            }
        });
});



